import { ChevronLeft, ChevronRight, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AccountMenu } from "@/components/app/AccountMenu";
import { useServices } from "@/context/ServicesContext";
import { LogoMark } from "@/components/app/Logo";
import { ThemePicker } from "@/components/app/ThemePicker";

export const TopBar = ({ year, setYear }) => {
  const { openNew, company } = useServices();
  return (
    <header className="sticky top-0 z-30 border-b border-slate-800 bg-slate-950/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1500px] items-center gap-3 px-4 py-3 sm:px-6 lg:px-10">
        <div className="flex min-w-0 items-center gap-2">
          <LogoMark className="h-9 w-9 shrink-0" />
          <div className="hidden min-w-0 leading-tight sm:block">
            <div className="truncate font-display text-lg font-extrabold tracking-tight" data-testid="brand-name">Ciclo Certo</div>
            {company?.company_name && <div className="truncate text-xs text-slate-400" data-testid="brand-company">{company.company_name}</div>}
          </div>
        </div>
        <div className="ml-auto flex items-center gap-1 rounded-full border border-slate-700 bg-slate-900 p-1">
          <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full" onClick={() => setYear(year - 1)} data-testid="year-prev-button" aria-label="Ano anterior">
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="w-14 text-center font-mono text-sm font-medium" data-testid="year-display">{year}</span>
          <Button size="icon" variant="ghost" className="h-8 w-8 rounded-full" onClick={() => setYear(year + 1)} data-testid="year-next-button" aria-label="Próximo ano">
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
        <Button onClick={() => openNew()} className="rounded-full font-semibold" data-testid="add-service-button">
          <Plus className="h-4 w-4 sm:mr-1" /> <span className="hidden sm:inline">Novo serviço</span>
        </Button>
        <ThemePicker />
        <AccountMenu />
      </div>
    </header>
  );
};
